<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Design system components
	import { Toggle } from '@Shelly/shelly-design-system';
	//Helpers

	export let extractAsDevice: boolean;
</script>

<Toggle size="m" id="toggle-extract-as-device" bind:checked={extractAsDevice}>
	{$format('settings_extract_peripheral_as_device', {
		default: 'Extract peripheral as device',
	})}
</Toggle>
